import Vue from 'vue'
import App from './App.vue'
import common from './assets/js/common.js'
import axios from 'axios'
import router from './router.js'
import store from './store.js'
import VueI18n from 'vue-i18n'
// import VueAMap from 'vue-amap'

Vue.use(VueI18n)
import constant from './assets/js/const.js'

// 初始化vue-amap
// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//     key: 'ba2881bb6ccec669f70519e7179bc314'
// })

axios.defaults.withCredentials=true;
// Vue.prototype.$axios = axios;
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.prototype.Common = common;

// if (!window.scrollTo) {
// 	window.scrollTo = function(option) {
// 		window.scrollLeft = option.left;
// 		window.scrollTop = option.top;
// 	};
// }
//
// if (!document.body.scrollTo) {
// 	Element.prototype.scrollTo = function(option) {
// 		this.scrollLeft = option.left;
// 		this.scrollTop = option.top;
// 	};
// }

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh_cn',
  messages: {
    'zh_cn': require('@/assets/language/zh_cn.json'),
    'en_us': require('@/assets/language/en_us.json'),
    'de_de': require('@/assets/language/de_de.json')
  }
})

import "./assets/css/config/reset.css"
import "./assets/css/app.styl"

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
});
